import { STATE_NAME as MOVING_CENTER_STATE } from '../moving-center.config';

export const STATE_NAME = `${MOVING_CENTER_STATE}.companies`;
const PAGE_TITLE = 'Book Your Move';

export function MovingCenterCompaniesConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATE_NAME, {
    url: '/companies',
    views: {
      '@': {
        template: `<upd-moving-center-companies></upd-moving-center-companies>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    titleBar: {
      title: PAGE_TITLE,
      icon: 'movingtruck',
    },
    analytics: {
      // Page event is dispatched within component in order to add dynamic data.
      ignore: true,
    },
    data: {
      permissions:
        'signedIn && hasMovingCenterData && isPremiumMovingCenterKind',
    },
  });
}
